var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNationBuilding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 48 42.3737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.39926 18.6477H46.6007C48.4671 18.5734 48.4657 15.908 46.6007 15.8343H1.39926C-0.467125 15.9087 -0.465718 18.5741 1.39926 18.6477ZM35.5723 4.06978C32.4445 1.44641 28.4846 0.00164982 24.422 0.00164982H23.578C15.8671 -0.110979 8.5907 5.55599 6.74513 13.0211H41.2548C40.3451 9.55013 38.3563 6.40478 35.5723 4.06978ZM46.6007 39.5604H45.4753V21.4611H37.7854V39.5603H34.972V21.4611H30.0955V39.5603H27.2822V31.6829H20.7177V39.5603H17.9044V21.4611H13.0279V39.5603H10.2145V21.4611H2.52461V39.5603H1.39973C-0.466656 39.6347 -0.465249 42.3001 1.39973 42.3737H46.6007C48.4671 42.2994 48.4657 39.634 46.6007 39.5604Z",
    fill: "var(--fill-0, #B707AB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.7168 21.4609H27.2812V28.8694H20.7168V21.4609Z",
    fill: "var(--fill-0, #B707AB)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationBuilding);
export default __webpack_public_path__ + "static/media/nation-building.95aa75fea9dc418d20ceb07a8cd3d0e1.svg";
export { ForwardRef as ReactComponent };